import { supabase } from './supabase';
import type { CoachingFormuleId } from '../config/coaching';

// Dernière demande de coaching payée. Volontairement PAS de notion de « réservation en cours » :
// la table ne porte aucune date de séance — created_at est l'instant du PAIEMENT — ni de cycle de
// vie au-delà de 'paid'. Rien ne distingue donc une séance à venir d'une séance déjà passée, et
// afficher une séance vieille de trois mois comme « à venir » ferait douter du reste de l'écran.
// Un vrai suivi demandera une colonne scheduled_at, dans un lot dédié.
export interface CoachingRequest {
  id: string;
  formule: CoachingFormuleId;
  created_at: string;
}

/**
 * Dernière demande payée de l'utilisateur, ou `null` s'il n'en a aucune.
 *
 * Lecture seule : la policy `coaching_requests_select_own` (0005) est toujours en place ; seule
 * l'insertion client a été retirée (0023), les lignes venant du webhook de paiement.
 */
export async function getLatestCoachingRequest(): Promise<CoachingRequest | null> {
  const { data, error } = await supabase
    .from('coaching_requests')
    .select('id, formule, created_at')
    .order('created_at', { ascending: false })
    .limit(1)
    .maybeSingle();
  if (error) throw error;
  return (data as CoachingRequest | null) ?? null;
}
